import React from 'react';
import classNames from 'classnames';
const StatusMessageTemplate = ({ message, type }) => {
    if (!message) return null;
    let icon = '';
    switch (type) {
        case 'error':
            icon = 'fas fa-exclamation-circle';
            break;
        case 'warning':
            icon = 'fas fa-exclamation-triangle';
            break;

        case 'info':
            icon = 'fas fa-exclamation-circle';
            break;
        default:
            break;
    }

    return (
        <div
            className={classNames({
                errorMessage: type === 'error',
                warningMessage: type === 'warning',
                infoMessage: type === 'info',
            })}
        >
            <i className={icon} title={message} />
            {message}
        </div>
    );
};

export default React.memo(StatusMessageTemplate);
